import styled from '@emotion/styled'

import ChooseFromDestinations from './components/chooseFromDestinations'
import PipeDataWarehouse from './components/pipelineDataWarehouse/PipeDataWarehouse'
import CombineData from './components/combineData/CombineData'
import MeasureUserActions from './components/measureUserActions/MeasureUserActions'

const PipelineSection = () => {
  return (
    <Wrapper>
      <MeasureUserActions />
      <CombineData />
      <ChooseFromDestinations />
      <PipeDataWarehouse />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.palette.twilio.gray[10]};
`

export default PipelineSection
